import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasAnalyticsConsent, trackPageView } from '@/analytics/ga';

/**
 * Sends GA4 page_view on client-side route changes after consent is granted.
 */
export function AnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    if (!hasAnalyticsConsent()) {
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
